import { CheckCircleIcon } from '@heroicons/react/outline';
import NoAuthTopBar from '@/components/NoAuthTopBar';
import { useHistory } from 'react-router-dom';

const SubmittedView = () => {
  const history = useHistory();
  return (
    <div className="flex flex-col items-center w-screen min-h-screen bg-mmj-gray">
      <NoAuthTopBar />
      <div className="w-full max-w-xl mx-auto px-4 py-8 md:py-16">
        <div className="bg-white p-6 md:p-10 rounded-xl shadow-mmj-lg text-center">
          <CheckCircleIcon
            className="mx-auto h-16 w-16 text-green-600 mb-4"
            aria-hidden="true"
          />
          <h1 className="text-2xl md:text-3xl font-bold text-mmj-header mb-4">
            Your intake form has been submitted
          </h1>
          <p className="text-lg text-mmj-header mb-4">
            Thank you. Your doctor will receive a copy automatically before your
            appointment.
          </p>
          <p className="text-base text-gray-700 mb-8">
            You can return to your dashboard anytime. A copy of your completed
            form will be available there shortly.
          </p>
          <button
            type="button"
            className="button button-primary w-full"
            style={{ minHeight: '56px', fontSize: '18px' }}
            onClick={() => history.push('/')}
          >
            Return to my dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubmittedView;
